import qukan from './Qukan'
import perm from './Perm'

export default {
    qukan,
    perm
};



// WEBPACK FOOTER //
// ./src/core/Apis/index.js